<style src="./TabQuoteList.scss" lang="scss">

</style>
<i18n src="./TabQuoteList.txt" lang="yaml"></i18n>
<script src="./TabQuoteList.js"></script>

<template>
  <div class="myaccount-content">
    <h3>{{ t('quotes') }}</h3>
    <Spinner v-if="loading" />
    <div class="myaccount-table table-responsive text-center" v-else-if="quoteListNotEmpty">
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th>{{ t('quoteId') }}</th>
            <th>{{ t('date') }}</th>
            <th v-if="isSellerUser">{{ t('userEmail') }}</th>
            <th v-if="isSellerUser">{{ t('userName') }}</th>
            <th>{{ t('total') }}</th>
            <th>{{ t('quoteRequestStatus') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="quote in quoteData" :key="quote.id" data-test="quote-list">
            <td data-test="quote-id">
              <router-link :to="{
                name: 'quote',
                params: { id: quote.id },
                query: {state: quote.quoteRequestState}
                }" 
                data-test="view-quote-btn"
                class="quote-id-link"
                :title="quote.id"
              >
                {{ quote.id }}
              </router-link>
            </td>
            <td data-test="quote-date">
              <BaseDate :date="quote.createdAt" :format="'short'" />
            </td>
            <td v-if="isSellerUser">{{ quote.customer?.email }}</td>
            <td v-if="isSellerUser">{{ quote.customer?.firstName }} {{ quote.customer?.lastName  }}</td>
            <td data-test="total-price">
              <BaseMoney :money="quote.totalPrice" />
            </td>
            <td data-test="quote-state">
              {{ quote.quoteRequestState }}
            </td>
            <!-- <td>
              <router-link :to="{
                name: 'quote',
                params: { id: quote.id },
                query: {state: quote.quoteRequestState}
              }" data-test="view-quote-btn">
                {{ t('view') }}
              </router-link>
              &nbsp;&nbsp;
              <a href="javascript:void(0)" v-if="!['Cancelled', 'Accepted'].includes(quote.quoteRequestState) && !isSellerUser"
                @click="showModal('cancelQuote', {quote: quote})">Cancel</a>
                &nbsp;&nbsp;
              <a href="javascript:void(0)" v-if="['Accepted'].includes(quote.quoteRequestState)"
                >Renegotiate</a>
                <a href="javascript:void(0)" v-if="['Cancelled'].includes(quote.quoteRequestState)"
                @click="showModal('deleteQuote', {quote: quote})">Delete</a>
            </td> -->
          </tr>
        </tbody>
      </table>
      <Pagination :total="total" :page="page" :setPage="setPage" />
    </div>
    <div v-else data-test="quote-order-list">
      <span>
        {{ t('emptyOrders') }}
      </span>
    </div>
    <Modal 
      v-if="isModalVisible" 
      size="sm"
      :secondaryBtn="{text: 'Cancel', callback: hideModal}"
      :primaryBtn="{text: 'Yes', callback: modalType === 'cancelQuote' ? submitCancelRequest: submitDeleteRequest}"
      :closeModalCallback="hideModal"
      :message="('Are you sure you want to' +(modalType === 'cancelQuote'? ' cancel ': ' delete ')+'the quote '+selectedQuote.id)"
      title="Cancel Quote"
      />
  </div>
</template>
